import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroupText,
  InputGroupAddon,
  InputGroup,
  FormGroup
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import PromosImagesForm from './PromosImagesForm';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import {
  gAPI_Promos_By_Id, gAPI_QuestionOptionList
} from '../../../../../../../constants/APIs';
import CustomSelectInput from '../../../../../../../components/common/CustomSelectInput';
import Select from "react-select";
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../../../helpers/IntlMessages';
function PromosForm({
  visible,
  toggle,
  formLabel,
  submit,
  updatePormosData,
  id,
  propertyId,
  locale
}) {
  const [isActive, setisActive] = useState(false)
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [promosData, setPromosData] = useState(
    updatePormosData || {
      name: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      displayText: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      displayFreeText: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      conditions: [
        {
          statement: 'Conditions',
          languageCode: locale,
        },
      ],
      type: 'PercentageDiscount',
      promotionUrl: '',
      availWithOtherOffer: false,
      discount: 15,
      stayDays: 0,
      payDays: 0,
      saveDays: 0,
      advanceBookingDays: 0,
      creator: 'Admin',
      dates: [
        {
          travelStartDate: '',
          travelEndDate: '',
          bookingStartDate: '',
          bookingEndDate: '',
          status: 'Active',
        },
      ],
      displayOrder: 1,
      searchTags: []
    }
  );
  useEffect(() => {
    if (id !== undefined) {
      setisActive(true)
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Promos_By_Id}/${id}`,
      })
        .then(res => {
          setPromosData(res.data);
          AxiosAPI({
            method: 'get',
            url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Promos`,
          })
            .then(res1 => {
              var options = [];
              try {
                res1.data.map(
                  (item) => options.push({ label: item.option, value: item.option, key: item.id })
                )
              }
              finally { }
              setTags(options);
              var selectedTags = [];
              try {
                res.data.searchTags.map(
                  (item) => selectedTags.push(options.filter((cat) => cat.value === item)[0])
                )
              }
              finally { }
              setselectedTags(selectedTags);
            })
            .catch(err => console.log('err', err));
        })
        .catch(err => console.log('err', err));
    }
    else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Promos`,
      })
        .then(res => {
          var options = [];
          try {
            res.data.map(
              (item) => options.push({ label: item.option, value: item.option, key: item.id })
            )
          }
          finally { }
          setTags(options);
        })
        .catch(err => console.log('err', err));
    }
  }, [id]);

  const handleAddDates = () => {
    const values = [...promosData.dates];
    values.push({
      travelStartDate: '',
      travelEndDate: '',
      bookingStartDate: '',
      bookingEndDate: '',
      currency: 'NZD',
      price: 0.0,
      taxIncluded: true,
      tax: 0.0,
      status: 'Active',
    });
    setPromosData({ ...promosData, dates: values });
  };
  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex(m => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(m => m.languageCode === 'en');
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      }
      else {
        return statements[index].statement;
      }
    }
  }
  const handleChangeNameArr = e => {
    if (promosData.name.length > 0) {
      const index = promosData.name.findIndex(m => m.languageCode === locale);
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        }
        setPromosData({
          ...promosData,
          name: [...promosData.name, newStatement]
        });
      }
      else {
        let newArr = [...promosData.name];
        newArr[index].statement = e.target.value
        setPromosData({
          ...promosData,
          name: newArr
        });
      }
    }
    else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      }
      setPromosData({
        ...promosData,
        name: [...promosData.name, newStatement]
      });
    }
  }


  const handleChangeDisplayTextArr = e => {
    if (promosData.displayText.length > 0) {
      const index = promosData.displayText.findIndex(m => m.languageCode === locale);
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        }
        setPromosData({
          ...promosData,
          displayText: [...promosData.displayText, newStatement]
        });
      }
      else {
        let newArr = [...promosData.displayText];
        newArr[index].statement = e.target.value
        setPromosData({
          ...promosData,
          displayText: newArr
        });
      }
    }
    else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      }
      setPromosData({
        ...promosData,
        displayText: [...promosData.displayText, newStatement]
      });
    }
  }

  const handleChangeDisplayFreeTextArr = e => {
    if (promosData.displayFreeText.length > 0) {
      const index = promosData.displayFreeText.findIndex(m => m.languageCode === locale);
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        }
        setPromosData({
          ...promosData,
          displayFreeText: [...promosData.displayFreeText, newStatement]
        });
      }
      else {
        let newArr = [...promosData.displayFreeText];
        newArr[index].statement = e.target.value
        setPromosData({
          ...promosData,
          displayFreeText: newArr
        });
      }
    }
    else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      }
      setPromosData({
        ...promosData,
        displayFreeText: [...promosData.displayFreeText, newStatement]
      });
    }
  }

  const handleChangeConditionsArr = e => {
    if (promosData.conditions.length > 0) {
      const index = promosData.conditions.findIndex(m => m.languageCode === locale);
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        }
        setPromosData({
          ...promosData,
          conditions: [...promosData.conditions, newStatement]
        });
      }
      else {
        let newArr = [...promosData.conditions];
        newArr[index].statement = e.target.value
        setPromosData({
          ...promosData,
          conditions: newArr
        });
      }
    }
    else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      }
      setPromosData({
        ...promosData,
        conditions: [...promosData.conditions, newStatement]
      });
    }
  }

  const handleChangeTags = selectedTags => {
    setselectedTags(selectedTags);
    const tagsArr = selectedTags
      .map(elem => elem.value);

    setPromosData({
      ...promosData,
      searchTags: tagsArr
    });
  };

  const handleRemoveDates = index => {
    const values = [...promosData.dates];
    values.splice(index, 1);
    setPromosData({ ...promosData, dates: values });
  };

  const handleDatesInputChange = (index, event) => {
    const values = [...promosData.dates];
    switch (event.target.name) {
      case 'travelStartDate':
        values[index].travelStartDate = event.target.value;
        break;
      case 'travelEndDate':
        values[index].travelEndDate = event.target.value;
        break;
      case 'bookingStartDate':
        values[index].bookingStartDate = event.target.value;
        break;
      case 'bookingEndDate':
        values[index].bookingEndDate = event.target.value;
        break;
      case 'currency':
        values[index].currency = event.target.value;
        break;
      case 'price':
        values[index].price = event.target.value;
        break;
      case 'taxIncluded':
        values[index].taxIncluded = event.target.value;
        break;
      case 'tax':
        values[index].tax = event.target.value;
        break;
      case 'status':
        values[index].status = event.target.value;
        break;

      default:
        break;
    }

    setPromosData({
      ...promosData,
      dates: values,
    });
  };

  const handleChangeArr = e => {
    const key = e.target.name;
    const value = e.target.value;
    setPromosData({
      ...promosData,
      [key]: [
        {
          statement: value,
          languageCode: 'en',
        },
      ],
    });
  };

  const handleChange = e => {
    setPromosData({
      ...promosData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    submit(promosData);
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              {/* <pre>{JSON.stringify(promosData, null, 2)}</pre> */}
              <Row>
                <Colxx sm={4} className="mb-3">
                  <Label>Promo Title</Label>
                  <Input
                    type="text"
                    value={getLocalStatement(promosData.name)}
                    onChange={handleChangeNameArr}
                    name="name"
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Display Text</Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(promosData.displayText)}
                    onChange={handleChangeDisplayTextArr}
                    name="displayText"
                  />
                </Colxx>
                {/* <Colxx sm={4} className="mb-3">
                  <Label>Display FreeText</Label>
                  <Input
                    type="textarea"
                    value={promosData.displayFreeText[0].statement}
                    onChange={handleChangeArr}
                    name="displayFreeText"
                  />
                </Colxx> */}
                <Colxx sm={4} className="mb-3">
                  <Label>Conditions</Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(promosData.conditions)}
                    name="conditions"
                    onChange={handleChangeConditionsArr}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Promo Type</Label>
                  <Input
                    type="select"
                    value={promosData.type}
                    name="type"
                    onChange={handleChange}
                  >
                    <option value="PercentageDiscount">Flat % Discount</option>
                    <option value="StayPay">
                      Free Nights When Staying Longer
                    </option>
                    <option value="StaySave">
                      % Discount When Staying Longer
                    </option>
                    <option value="AdvanceBooking">
                      % Discount When Booking in Advance
                    </option>
                  </Input>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Link to Promo Page (if available)</Label>
                  <Input
                    type="text"
                    value={promosData.promotionUrl}
                    name="promotionUrl"
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Available with Other Offers</Label>
                  <Input
                    type="select"
                    value={promosData.availWithOtherOffer}
                    name="availWithOtherOffer"
                    onChange={handleChange}
                  >
                    <option value={false}>No</option>
                    <option value={true}>Yes</option>
                  </Input>
                </Colxx>
                {(promosData.type === 'PercentageDiscount' ||
                  promosData.type === 'StaySave' || promosData.type === 'AdvanceBooking') && (
                    <Colxx sm={4} className="mb-3">
                      <Label>Discount</Label>
                      <InputGroup>
                        <Input
                          type="number"
                          min={0}
                          value={promosData.discount}
                          name="discount"
                          onChange={handleChange}
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText>%</InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </Colxx>
                  )}
                {promosData.type === 'StayPay' && (
                  <Colxx sm={4} className="mb-3">
                    <Label>Booked Nights</Label>
                    <Input
                      type="number"
                      min={0}
                      value={promosData.stayDays}
                      name="stayDays"
                      onChange={handleChange}
                    />
                  </Colxx>
                )}
                {promosData.type === 'AdvanceBooking' && (
                  <Colxx sm={4} className="mb-3">
                    <Label>Advance Booking Days</Label>
                    <Input
                      type="number"
                      min={0}
                      value={promosData.advanceBookingDays}
                      name="advanceBookingDays"
                      onChange={handleChange}
                    />
                  </Colxx>
                )}
                {promosData.type === 'StayPay' && (
                  <Colxx sm={4} className="mb-3">
                    <Label>Paid Nights</Label>
                    <Input
                      type="number"
                      min={0}
                      value={promosData.payDays}
                      name="payDays"
                      onChange={handleChange}
                    />
                  </Colxx>
                )}
                {promosData.type === 'StaySave' && (
                  <Colxx sm={4} className="mb-3">
                    <Label>Minimum Nights</Label>
                    <Input
                      type="number"
                      min={0}
                      value={promosData.saveDays}
                      name="saveDays"
                      onChange={handleChange}
                    />
                  </Colxx>
                )}
                {isActive === true && (
                  <Colxx sm={4} className="mb-3">
                    <Label>Status</Label>
                    <Input
                      type="select"
                      value={promosData.status}
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="Draft">Draft</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                      <option value="Archived">Archived</option>
                    </Input>
                  </Colxx>
                )}
                <Colxx sm={3}>
                  <Label for="displayOrder">
                    <IntlMessages id='dashboards.displayOrder' />
                  </Label>
                  <Input
                    type="number"
                    name="displayOrder"
                    min={0}
                    value={promosData.displayOrder}
                    onChange={handleChange}
                  />

                </Colxx>
                <Colxx sm={6}>
                  <FormGroup>
                    <Label for="bookingUrl">
                      Search Tags
                    </Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedTags}
                      onChange={handleChangeTags}
                      options={tags}
                    />
                  </FormGroup>
                </Colxx>
              </Row>
            </Colxx>
          </Row>
          <h4>Promo Validity Dates</h4>
          {promosData.dates.map((tariff, index) => (
            <Row key={`${tariff}~${index}`} style={{ marginBottom: '30px' }}>
              <Colxx sm={3} className="mb-3">
                <Label>Travel Start Date</Label>
                <Input
                  required
                  type="date"
                  name="travelStartDate"
                  value={moment(tariff.travelStartDate).format('YYYY-MM-DD')}
                  onChange={event => handleDatesInputChange(index, event)}
                />
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Travel End Date</Label>
                <Input
                  required
                  type="date"
                  name="travelEndDate"
                  value={moment(tariff.travelEndDate).format('YYYY-MM-DD')}
                  onChange={event => handleDatesInputChange(index, event)}
                />
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Booking Start Date</Label>
                <Input
                  required
                  type="date"
                  name="bookingStartDate"
                  value={moment(tariff.bookingStartDate).format('YYYY-MM-DD')}
                  onChange={event => handleDatesInputChange(index, event)}
                />
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Booking End Date</Label>
                <Input
                  required
                  type="date"
                  name="bookingEndDate"
                  value={moment(tariff.bookingEndDate).format('YYYY-MM-DD')}
                  onChange={event => handleDatesInputChange(index, event)}
                />
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Status</Label>
                <Input
                  required
                  name="status"
                  type="select"
                  onChange={event => handleDatesInputChange(index, event)}
                  value={tariff.status}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </Input>
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label style={{ opacity: '0%' }}>-</Label>
                <div>
                  <Button
                    onClick={handleAddDates}
                    color="primary"
                    size="xs"
                    outline
                    style={{ margin: '6px' }}
                  >
                    + Add Date
                  </Button>
                  {promosData.dates.length > 1 && (
                    <Button
                      onClick={() => handleRemoveDates(index)}
                      color="secondary"
                      size="xs"
                      outline
                      style={{ margin: '6px' }}
                    >
                      -
                    </Button>
                  )}
                </div>
              </Colxx>
            </Row>
          ))}
          {promosData.images && (
            <PromosImagesForm images={promosData.images} id={id} />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

PromosForm.propTypes = {
  formLabel: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  updatepromosData: PropTypes.shape({
    name: PropTypes.array.isRequired,
    displayText: PropTypes.array.isRequired,
    displayFreeText: PropTypes.array.isRequired,
    conditions: PropTypes.array.isRequired,
    status: PropTypes.string.isRequired,
    dates: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
};
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};
export default injectIntl(connect(mapStateToProps)(PromosForm));